import React from 'react';
import { Calendar } from 'lucide-react';
import { TimeRangePreset, DateRange } from '../../types/dashboard';
interface DateRangePickerProps {
  selectedPreset: TimeRangePreset;
  onPresetChange: (preset: TimeRangePreset) => void;
  dateRange: DateRange;
  onRangeChange: (range: DateRange) => void;
}
const PRESETS: TimeRangePreset[] = ['Today', 'Yesterday', 'This Week', 'Last Week', 'This Month', 'Last Month', 'This Year', 'All Time'];
export function DateRangePicker({
  selectedPreset,
  onPresetChange,
  dateRange,
  onRangeChange
}: DateRangePickerProps) {
  const handlePresetClick = (preset: TimeRangePreset) => {
    onPresetChange(preset);
  };
  return <div className="flex flex-col gap-3" data-id="element-177">
      {/* Preset Buttons */}
      <div className="flex flex-wrap gap-2" data-id="element-178">
        {PRESETS.map(preset => <button key={preset} onClick={() => handlePresetClick(preset)} className={`px-4 py-2 text-sm font-medium rounded-lg transition-all ${selectedPreset === preset ? 'bg-blue-600 text-white shadow-sm' : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 hover:border-gray-400'}`} data-id="element-179">
            {preset}
          </button>)}
      </div>

      {/* Custom Date Range */}
      <div className="flex items-center gap-3 pt-2 border-t border-gray-200" data-id="element-180">
        <div className="flex items-center text-gray-500" data-id="element-181">
          <Calendar className="h-4 w-4 mr-2" data-id="element-182" />
          <span className="text-sm font-medium" data-id="element-183">Custom Range:</span>
        </div>

        <div className="flex items-center gap-2" data-id="element-184">
          <input type="date" className="text-sm border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none" value={dateRange.start.toISOString().split('T')[0]} onChange={e => onRangeChange({
          ...dateRange,
          start: new Date(e.target.value)
        })} data-id="element-185" />
          <span className="text-gray-400 text-sm font-medium" data-id="element-186">to</span>
          <input type="date" className="text-sm border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none" value={dateRange.end.toISOString().split('T')[0]} onChange={e => onRangeChange({
          ...dateRange,
          end: new Date(e.target.value)
        })} data-id="element-187" />
        </div>
      </div>
    </div>;
}